import React, { Component } from 'react'
import CardForm from 'Utils/Cards/CardForm';
import LoadMask from 'Utils/LoadMask/LoadMask';
import LaboratorioSolidoForm from './LaboratorioSolidoForm';
import AnularModal from "../../Ingresos/Pesar/Anular/AnularModal";

export default class LaboratorioCrear extends Component {
    state= {
        open: false,
        open_drc: false,
        open_tsc: false,
        open_vfa: false,
        open_nh3: false,
        ver_info: false
    };
    componentWillMount(){
        // this.props.initialLoad();
        this.props.setTab("SÓLIDOS");
        if(this.props.match.params.id){
            this.props.leer(this.props.match.params.id);
        }
    }
    actualizar = (data) =>{
        // Se recupera el registro para no crear un duplicado al volver a llamar a 'ediar()' en 'actualizarYEnviarValidacion()'
        this.props.editar(this.props.match.params.id, data).then(() => this.props.leer(this.props.match.params.id));
    };

    openModal = (tipo) => {
        if (tipo === "anular_recepcion"){
            this.setState({open:  true})
        }
        if (tipo === "drc"){
            this.setState({open_drc:  true})
        }
    };

    closeModal = (tipo) => {
        this.setState({open:  false});
        this.setState({open_drc:  false});
    };
    toogleInfo = () => {
        this.setState({ver_info: !this.state.ver_info})
    };

    anularRecepcion = (data) => {
        const id_anulacion = this.props.item.ingreso ? this.props.item.ingreso.id : this.props.item.id;
        this.props.anularIngreso(id_anulacion, data);
        this.closeModal()
    };

    actualizarYEnviarValidacion = (data) => {
        this.props.editar(this.props.match.params.id, data).then(() => this.props.enviar_a_validacion(this.props.item.id));
    };

    render() {
        const { updateData, loader, configuraciones } = this.props;
        return (
            <div className="mb-4 col-12">
                <CardForm
                    icon="laboratorio_activo"
                    titulo="LABORATORIO"
                    subtitulo="Materia prima"
                    col="12"
                >
                    <LoadMask loading={loader} blur>
                        <AnularModal open={this.state.open} closeModal={this.closeModal} item={this.props.item} anularRecepcion={this.anularRecepcion}/>
                        <LaboratorioSolidoForm
                            onSubmit={this.actualizar}
                            updateData={updateData}
                            editando={true}
                            {...this.props}
                            {...this.state}
                            anularRecepcion={this.anularRecepcion}
                            openModal={this.openModal}
                            closeModal={this.closeModal}
                            toogleInfo={this.toogleInfo}
                            actualizarYEnviarVaciado={this.actualizarYEnviarVaciado}
                            actualizarYEnviarValidacion={this.actualizarYEnviarValidacion}
                        />
                    </LoadMask>
                </CardForm>
            </div>
        )
    }
}
